<template>
  <div class="inventory-item-history-sidesheet" @keydown.esc="close">
    <files-viewer ref="viewer" />

    <c-sidesheet :active="active" @close="close">
      <div class="modal-frame">
        <div class="modal-wrapper">
          <shadow-scroll-container ref="track" class="modal-track" :with-top-scroller="true">
            <div class="inventory-item-history">
              <div class="inventory-item-history__wrapper">
                <div class="modal-frame__header">
                  <h2 class="modal-frame__title">
                    <template v-if="item">
                      История действий с ТМЦ <span class="font-weight-normal">№{{ item.serialNumber }}</span>
                      <div v-if="item.name" class="item-name">{{ item.name }}</div>
                    </template>
                  </h2>
                </div>

                <div v-if="loading">
                  <c-loader
                    class="inventory-items-table__loading"
                    :active="true"
                    label="Данные загружаются"
                    :height="200"
                  ></c-loader>
                </div>
                <div v-else-if="!items.length">
                  <div class="inventory-items-table__empty">Действий с ТМЦ пока не производилось</div>
                </div>
                <div v-else>
                  <div class="lg">
                    <table class="h-table">
                      <thead>
                        <tr>
                          <th>
                            <div class="h-table__header">
                              <div class="h-table__col-title nowrap-title" >Дата операции</div>
                            </div>
                          </th>
                          <th>
                            <div class="h-table__header">
                              <div class="h-table__col-title nowrap-title">Автор операции</div>
                            </div>
                          </th>
                          <th>
                            <div class="h-table__header">
                              <div class="h-table__col-title">Тип операции</div>
                            </div>
                          </th>
                          <th>
                            <div class="h-table__header">
                              <div class="h-table__col-title">Комментарий</div>
                            </div>
                          </th>
                          <th>
                            <div class="h-table__header">
                              <div class="h-table__col-title">Файлы</div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="action in items" :key="action.id">
                          <td>
                            {{ action.date }}
                          </td>
                          <td>
                            <worker-or-user v-if="action.actor" :value="action.actor" />
                          </td>
                          <td>
                            {{ action.type }}
                            <worker-or-user v-if="action.worker" :value="{ worker: action.worker }" />
                          </td>
                          <td>
                            {{ action.comment || "—" }}
                          </td>
                          <td>
                            <div class="action-files" @click="showActionFiles(action)">{{ action.filesText }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="sm">
                    <horizontal-table v-if="(!loading || page > 1) && items.length" @nextPage="$emit('nextPage')">
                      <table class="h-table">
                        <tbody>
                          <tr>
                            <th>
                              <div class="h-table__header">
                                <div class="h-table__col-title">Дата операции</div>
                              </div>
                            </th>
                            <td v-for="action in items" :key="action.id">
                              {{ action.date }}
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <div class="h-table__header">
                                <div class="h-table__col-title">Автор операции</div>
                              </div>
                            </th>
                            <td v-for="action in items" :key="action.id">
                              <worker-or-user v-if="action.actor" :value="action.actor" />
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <div class="h-table__header">
                                <div class="h-table__col-title">Тип операции</div>
                              </div>
                            </th>
                            <td v-for="action in items" :key="action.id">
                              {{ action.type }}
                              <worker-or-user v-if="action.worker" :value="{ worker: action.worker }" />
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <div class="h-table__header">
                                <div class="h-table__col-title">Комментарий</div>
                              </div>
                            </th>
                            <td v-for="action in items" :key="action.id">
                              {{ action.comment || "—" }}
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <div class="h-table__header">
                                <div class="h-table__col-title">Файлы</div>
                              </div>
                            </th>
                            <td v-for="action in items" :key="action.id">
                              <div class="action-files" @click="showActionFiles(action)">{{ action.filesText }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </horizontal-table>
                  </div>
                </div>
              </div>
            </div>
          </shadow-scroll-container>
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import CSidesheet from "@/components/sidesheet";
import ShadowScrollContainer from "@/components/shadow-scroll-container";
import WorkerOrUser from "@/components/user/worker-or-user";
import CLoader from "@/components/loader";
import HorizontalTable from "@/components/horizontal-table";
import FilesViewer from "@/components/files-viewer";

import { HistoryAction } from "./models/HistoryAction";

export default {
  components: {
    CSidesheet,
    ShadowScrollContainer,
    WorkerOrUser,
    HorizontalTable,
    CLoader,
    FilesViewer,
  },

  data() {
    return {
      active: false,
      loading: false,
      item: null,
      items: [],
    };
  },

  computed: {
    title() {
      return "История действий";
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },

  methods: {
    open(item) {
      this.item = item;
      this.loading = true;
      this.$store.dispatch("uniformItems/getItemHistory", item.id).then((items) => {
        if (this.item.id !== item.id) return;
        this.items = items.map(HistoryAction);
        this.loading = false;
      });
      this.active = true;
    },

    close() {
      this.item = null;
      this.active = false;
      this.$emit("close");
    },

    showActionFiles(action) {
      this.$refs.viewer.open(action.files);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
@import "~@/assets/styles/grid.scss";

/deep/ {
  .sidesheet {
    &__header {
      display: none;
    }
    &__wrapper {
      padding: 0 !important;
      z-index: 1001;
    }

    &__content {
      height: 100%;
      padding: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &__close {
      padding-right: 10px;
      padding-top: 10px;
    }
  }
}

.modal-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .modal-wrapper {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  .modal-track {
    width: 100%;
    height: 100%;

    /deep/ {
      .scroll-container {
        padding-right: 0;
      }
    }
  }

  &__header {
    margin-bottom: 30px;
  }

  &__title {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 500;
  }

  @include bootstrapMd {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__title {
      font-size: 22px;
      margin-bottom: 0;
    }
  }
}

.item-name {
  font-size: 15px;
  font-weight: normal;
  margin-top: 4px;
}

.h-table__col-title {
  cursor: default!important;
}

.inventory-item-history {
  &__wrapper {
    padding: 0 20px 20px;
  }

  .action-files {
    color: $color-primary;
    white-space: nowrap;
    cursor: pointer;
  }

  &__empty {
    color: #8e9cbb;
    font-size: 13px;
  }

  &__category {
    padding-top: 6px;
  }

  .sm {
    display: none;
    position: relative;

    /deep/ {
      th {
        width: 120px;
        min-width: 120px;
        max-width: 120px;
      }
      td {
        width: calc(100vw - 120px);
        min-width: calc(100vw - 120px);
        max-width: calc(100vw - 120px);
      }
    }
  }

  @include onlyMobile {
    .inventory-item-history__wrapper {
      padding-top: 35px;
    }
    .lg {
      display: none;
    }
    .sm {
      display: block;
      margin-left: -21px;
      margin-right: -21px;
    }
  }
}

@include bootstrapMd {
  .inventory-item-history {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 40px;
    padding-top: 25px;

    &__wrapper {
      padding-bottom: 40px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.nowrap-title {
  white-space: nowrap;
}
</style>
